import { staticRoutesWithCustomSidebar } from 'Deer/constants/staticRoutesWithCustomSidebar';
import { useSelector } from 'react-redux';
import { matchPath, useLocation } from 'react-router-dom';
import { useCurrentProvider } from 'reducers/reviewResultSlice';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';

import { getQueryParams } from 'constants/helper';
import { routes } from 'constants/routes';

const useReviewResultParams = () => {
  const location = useLocation();
  const { params } =
    matchPath(location.pathname, {
      path: [
        routes.performanceReview.result,
        routes.performanceReview.resultChartOnly,
        staticRoutesWithCustomSidebar.reviewsResultPage,
        staticRoutesWithCustomSidebar.reviewsResultChartOnlyPage,
      ],
      exact: true,
    }) ?? {};
  const { employeeId, reviewId } = params ?? {};
  const { id } = useCurrentProvider();
  const queryParams = getQueryParams(location.search);
  const loggedInEmployee = useSelector(selectLoggedInEmployeeData);

  const providerId = id ?? queryParams.provider ?? loggedInEmployee?.id;
  return {
    employeeId,
    reviewId,
    providerId,
  };
};

export default useReviewResultParams;
